import { request } from "../helpers/axios.new";
import AxiosConfigs from "../configs/axios";

const { REACT_APP_LINK_HOST: apiUrl } = AxiosConfigs;

// Workspace dashboard layouts use the SAME deployed API as the rest of the
// app (REACT_APP_LINK_HOST → api.gamemybiz.com). Until the server ships the
// /api/workspace-layout routes, callers fall back to localStorage (see
// pages/Homepage/customize/layoutStore.js) — same pattern as dashboards.
const base = `${apiUrl}/api/workspace-layout`;

export const GET_WORKSPACE_LAYOUT = (workspaceId) =>
  request({ url: `${base}/${workspaceId}`, method: "GET" });

export const PUT_WORKSPACE_LAYOUT = (workspaceId, data) =>
  request({ url: `${base}/${workspaceId}`, method: "PUT", data });
